import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

// Security measures to prevent inspection - commented out for development
// Production version can uncomment these if needed
(function() {
  // Only apply in production environment
  if (import.meta.env.PROD) {
    // Disable right-click
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });
    
    // Disable keyboard shortcuts for dev tools
    document.addEventListener('keydown', (e) => {
      // F12 key
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+I / Cmd+Option+I
      if ((e.ctrlKey && e.shiftKey && e.key === 'I') || 
          (e.metaKey && e.altKey && e.key === 'i')) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+J / Cmd+Option+J
      if ((e.ctrlKey && e.shiftKey && e.key === 'J') || 
          (e.metaKey && e.altKey && e.key === 'j')) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+C / Cmd+Option+C
      if ((e.ctrlKey && e.shiftKey && e.key === 'C') || 
          (e.metaKey && e.altKey && e.key === 'c')) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+U / Cmd+Option+U
      if ((e.ctrlKey && e.key === 'u') || 
          (e.metaKey && e.altKey && e.key === 'u')) {
        e.preventDefault();
        return false;
      }
    });
    
    // Prevent copy/paste operations in production
    document.addEventListener('copy', (e) => {
      e.preventDefault();
      return false;
    });
    
    document.addEventListener('cut', (e) => {
      e.preventDefault();
      return false;
    });
    
    // Disable text selection
    document.addEventListener('selectstart', (e) => {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        return false;
      }
    });
    
    // Console warning
    const warningMessage = "%c⚠️ Security Alert: This is a secured environment. Any attempt to inspect or modify this application is strictly prohibited and may result in legal action.";
    console.log(warningMessage, "color:red; font-size:18px; font-weight:bold;");
  }
})();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);